<template>
	<div class="comp">
		<el-dialog :visible.sync="dialogState" width="1530px" top="50px">
			<div style="display: flex;font-size: 18px;padding-bottom:10px;padding-left:10px;">
				<span style="padding-right: 80px;">会员名称：
					<span style="font-weight:bold" v-if="userInfo.basic_info">{{userInfo.basic_info.nick_name}}</span>
				</span>
				<span style="padding-right: 80px;">会员卡：
					<span style="font-weight:bold" v-if="userInfo.club_card">{{userInfo.club_card.is_valid?'是':'否'}}</span>
				</span>
				<span style="padding-right: 80px;">可用余额：
					<span style="font-weight:bold" v-if="userInfo.card_info">{{userInfo.card_info.user_yue}} 元</span>	
				</span>
				<span style="padding-right: 80px;">可用押金：
					<span style="font-weight:bold" v-if="userInfo.card_info">{{userInfo.card_info.user_yajin}} 元</span>	
				</span>
				<span style="padding-right: 80px;">宠物：
					<span style="font-weight:bold" >{{curPetInfo.nick_name}}</span>	
				</span>
			</div>
			<div style="height: 650px;overflow-y: scroll;position: relative;">
				<el-table :data="tableData" style="width: 100%;min-height: 650px;" v-loading="tableData.length===0" :empty-text="'加载中...'">
					<el-table-column label="编号" width="50">
						<template slot-scope="props">
							{{parseInt(props.$index+1)}}
						</template>
					</el-table-column>
					<el-table-column label="日期" >
						<template slot-scope="props">
							<div >{{$public.FTime(props.row.fosterCareDate)}}</div>
						</template>
					</el-table-column>
					<el-table-column label="项目" prop="goodsName">
						<template slot-scope="props">
							{{props.row.goodsName+' '+props.row.skuValue}}
						</template>
					</el-table-column>
					<el-table-column label="标准价/会员价" prop="originalPrice" >
						<template slot-scope="props">
							{{props.row.originalPrice}}/
							{{props.row.vipPrice>0?props.row.vipPrice:props.row.originalPrice+'元 / '+props.row.unit}}
						</template>
					</el-table-column>
					<el-table-column label="活动" >
						<template slot="header">
							活动
						</template>
						<template slot-scope="scope">
							<el-select
							v-model="scope.row.activityId"
							:disabled="!scope.row.canActivity"
							@change="changeActivityId(scope.row)"
							placeholder="请选择"
							size="mini"
							style="width:130px;"
							clearable>
								<el-option
								v-for="item in scope.row.activityList"
								:key="item._id"
								:label="item.name"
								:value="item._id"
								:disabled="!$public.calcActivity(item,$public.cheng(scope.row.originalPrice,scope.row.num),scope.row.num).state"
								></el-option>
							</el-select>
						</template>
					</el-table-column>
					<el-table-column label="优惠价" prop="price">
					</el-table-column>
					<el-table-column label="数量" prop="num">
					</el-table-column>
					<el-table-column label="小计" >
						<template slot-scope="props">
							<div >{{$public.cheng(props.row.price,props.row.num)}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="payLine">
				<div class="payLineL">
					<span class="text">
						总计：￥<b style="font-size: 26px;">{{total}}</b>
					</span>
					<span class="text">
						会员价：￥<b style="font-size: 26px;">{{vipTotal}}</b>
					</span>
					<span class="text" style="margin-right:50px;">
						优惠金额：￥<b style="font-size: 26px;">{{$public.jian(total,activityTotal)}}</b>
					</span>
				</div>
				<div class="payLineR">
					<button v-if="userInfo.club_card&&userInfo.club_card.is_valid==false&&userInfo.card_info.user_yue>0&&showVip" class="btn" 
						style="background-color:#1890FF ;border: none;" @click="submit(1)"
						 :disabled="vipTotal>userInfo.card_info.user_yue||total==vipTotal">
						结束寄养会员价支付{{vipTotal}} 
					</button>
					<div class="btn" style="background-color: #F5882A;" @click="submit()">
						结束寄养支付￥{{activityTotal}}
					</div>
				</div>
			</div>
		</el-dialog>
		<!-- 结算 -->
		<div v-if="dialogSettlementState">
			<dialogSettlement :type="'order'" :orderId="curOrder._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "../../../components/dialog_settlement.vue"
	export default {
		components:{dialogSettlement},
		data() {
			return {
				dialogState:true,
				tableData:[],
				userInfo:{},
				curPetInfo:{},
				vipTotal:0,
				total:0,
				activityTotal:0,
				showVip:false,
				// 结算
				dialogSettlementState:false,
				curOrder:'',
				
			}
		},
		props:{
			stopJiyangData:{
				default:()=>{
					return {}
				}
			},
		},
		watch:{
			dialogState(){
				this.$emit('submit',{type:'close'})
			}
		},
		mounted() {
			this.$util.getUserInfo(this.stopJiyangData.memberId).then(data=>{
				this.userInfo = data;
				this.tableData = JSON.parse(JSON.stringify(this.stopJiyangData.pets[0].goodsList));
				for(let i=0;i<this.userInfo.pets_info.length;i++){
					if(this.userInfo.pets_info[i]._id===this.stopJiyangData.pets[0].petId){
						this.curPetInfo = this.userInfo.pets_info[i]
					}
				}
				this.$nextTick(()=>{
					for(let i=0;i<this.tableData.length;i++){
						this.tableData[i].activityId = '';
						this.tableData[i].activityItem=null;
						this.tableData[i].activityList=[];
					}
					this.getActivityListByArr(this.tableData)
				})
			})
		},
		methods: {
			submit(type){
				console.log(type,'000');
				let activityList = [];
				for(let i=0;i<this.tableData.length;i++){
					activityList.push({
						"goodsItemsId": this.tableData[i].goodsItemsId,
						"activityId":this.tableData[i].activityId ? this.tableData[i].activityId : '',
						"activityName": this.tableData[i].activityId ? this.tableData[i].activityItem.name : '',
						"price": this.tableData[i].price,
						"payType":this.tableData[i].activityId ? this.tableData[i].activityItem.pay_type : '',
					})
				}
				let params = {
					useVipPrice: type==1?true:false,
					id:this.stopJiyangData.pets[0].recordId,
					activityList:activityList,
				}
				let loading = this.$loading();
				this.$http.post('/api/FosterCare/FinishPet', params).then(res => {
					loading.close();
					if (res.code == 0) {
					this.curOrder = res.data;
					this.dialogSettlementState = true;
						// if(str==='pay'){
						// 	this.curOrder = res.data;
						// 	this.dialogSettlementState = true;
						// }else{
						// 	this.$message({
						// 		message: '保存成功',
						// 		type: 'success'
						// 	});
						// 	this.$emit('submit',{type:'success'})
						// }
						
					}
				})
			},
			////////////////// 结算
			dialogSettlementSubmit(a) {
				this.dialogSettlementState = false;
				if (a == 'close') {
					console.log(a)
					this.$emit('submit',{type:'close'})
				} else if (a == 'fail') {
					this.$message({
						message: '结算失败',
						type: 'error'
					});
					this.$emit('submit',{type:'close'})
				} else if (a == 'success') {
					this.$message({
						message: '结算成功',
						type: 'success'
					});
					this.$emit('submit',{type:'success'})
				}
			},
			/////////////////////////////    活动    //////////////////////////
			changeActivityId(row){
				if(this.$public.isNull(row.activityId)){
					console.log("取消活动",row)
					if(this.userInfo.club_card&&this.userInfo.club_card.is_valid==true&&row.vipPrice>0){
          row.price = row.vipPrice;
        }else{
					row.price = row.originalPrice;
				}
					row.activityItem = {};
					// row.giftList = [];
					// this.o.init(this.tableData)
				}else{
					row.activityItem = {};
					// row.giftList = [];
					let activityItem = this.$public.getMatchingItem(row.activityList,'_id',row.activityId)
					let calcResult=this.$public.calcActivity(activityItem,this.$public.cheng(row.originalPrice,row.num),row.num)
					console.log(calcResult)
					
					row.price = this.$public.chu(calcResult.newPrice,row.num);
					row.activityItem = activityItem;
					// if(!this.$public.isNull(calcResult.gift.give_list)){
					// 	this.curIndex = row.index;
					// 	this.giveGoods = calcResult.gift;
					// 	this.drawerGift_state = true;
					// }
				}
				this.getTotal()
			},
			getActivityListByArr(arr){
				this.$util.getActivityOfProduct(this.userInfo,arr,this.curPetInfo).then(res=>{
					for(let i=0;i<arr.length;i++){
						let arrItem = arr[i]
						arrItem.activityList=res[i].list
						if(!this.$public.isNull(res[i].list)&&res[i].list[0].auto_matching>0){
							if(arrItem.canActivity===true){
								arrItem.activityId = res[i].list[0]._id;
								arrItem.activityItem = res[i].list[0];
								let calcResult=this.$public.calcActivity(arrItem.activityItem,this.$public.cheng(arrItem.originalPrice,arrItem.num),arrItem.num)
								console.log(calcResult)
								arrItem.price = this.$public.chu(calcResult.newPrice,arrItem.num);
							}
						}
						this.$set(arr,i,arrItem)
					}
					this.getTotal()
				})
			},
			getTotal(){
				let arr = this.tableData;
				let total=0;
				let activityTotal=0;
				let vipTotal=0;
				let showVip=false;
				for(let i=0;i<arr.length;i++){
					console.log(arr[i],'arr');
					if(arr[i].price>0){
						if(this.$public.isNull(arr[i].activityId)&&arr[i].vipPrice>0){
							showVip=true
							vipTotal = this.$public.jia(vipTotal,this.$public.cheng(arr[i].vipPrice,arr[i].num))
						}else{
							vipTotal = this.$public.jia(vipTotal,this.$public.cheng(arr[i].price,arr[i].num))
						}
						total = this.$public.jia(total,this.$public.cheng(arr[i].originalPrice,arr[i].num))
					activityTotal = this.$public.jia(activityTotal,this.$public.cheng(arr[i].price,arr[i].num))
				
					}
				
				}
				this.showVip=showVip
				this.total = total
				this.vipTotal = vipTotal
				this.activityTotal = activityTotal
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		::v-deep .el-dialog__body{
			padding-top:10px;
		}
		.payLine{
			display: flex;
			justify-content: space-between;
			padding-top:30px;
			.payLineL{
				.text{
					font-size: 16px;
					line-height: 48px;
					margin-right: 30px;
				}
			}
			.payLineR{
				.text{
					font-size: 16px;
					margin-right: 30px;
				}
				.btn{
					display: inline-block;
					color:white;
					height: 50px;
					padding: 0 20px;
					// width:120px;
					border-radius: 4px;
					text-align: center;
					line-height: 48px;
					margin-right: 35px;
					cursor: pointer;
					.img{
						width:20px;
						height: 20px;
						margin-right: 4px;
						vertical-align: sub;
					}
				}
			}
		}
	}
</style>
